import store from '@src/util/store'
/**
 * 判定对象是否为空 null|undefined， Array.length = 0, string.length = 0
 * @param val
 */
export function isEmpty(val: any) {
	if (typeof val === 'number') return false
	else if (typeof val === "boolean") return false
	else if (typeof val === 'string' && val.trim().length == 0) return true
	else if (Array.isArray(val) && val.length === 0) return true
	else if (!val) return true
}

export const isIOS = /\(i[^;]+;( U;)? CPU.+Mac OS X/.exec(navigator.userAgent) //navigator.userAgent.match()
export const isAndroid = false

/**
 * 获取 url query参数
 * @param search
 */
export function getQueryParams(search?: string) {
	search = search || location.search
	const params: any = {}
	if (!isEmpty(search)) {
		search = search.replace(/\?/g, '')
		// search = decodeURIComponent(search)
		const searchArr = search.split('&')
		searchArr.forEach(item => {
			const kv = item.split('=')
			if (!isEmpty(kv[1]) && kv[1] !== 'null')
				params[kv[0]] = decodeURIComponent(kv[1])
		})
	}
	return params
}
/**
 * 获取基础配置信息
 * @param key
 * @param defaultVal
 */
export function getConfigByKey(key: string, defaultVal?: any) {
	const baseConfig = store.get('basics')
	if (!baseConfig) return defaultVal
	const baseObj = store.get('basics')[key]
	// 过滤禁用数据
	baseObj.items = baseObj.items.filter((item: any) => {
		return !item.disable
	})
	return configToOption(baseObj.items)
}
/**
 * 基础配置项转化为 selector 数据集
 * @param items
 */
export function configToOption(items: any): Array<{ value: string, label: string }> {
	return items.map((i: any) => ({ value: i.code, label: i.name }))
}
/**
 * 设置页面title
 * @param title
 */
export function setTitle(title?: string | null) {
	document.title = title || ""
}

export function base64ToBlob(data: string, type: string) {
	// const arr = urlData.split(',');
	// const match = /:(.*?);/.exec(arr[0]) || []
	// const mime = match[1] || type;
	// 去掉url的头，并转化为byte
	const bytes = window.atob(data);
	// 处理异常,将ascii码小于0的转换为大于0
	const ab = new ArrayBuffer(bytes.length);
	// 生成视图（直接针对内存）：8位无符号整数，长度s1个字节
	const ia = new Uint8Array(ab);
	for (let i = 0; i < bytes.length; i++) {
		ia[i] = bytes.charCodeAt(i);
	}
	return new Blob([ab], {
		type: type
	});
}

export function ObjToForm(data: { [k: string]: any }) {
	const form = new FormData()
	for (const k in data) {
		if (!isEmpty(data[k])) {
			form.append(k, data[k])
		}
	}
	return form
}


/**
 * 懒加载 url
 * @param url
 */
export function lazyLoadScript(url: string) {
	return new Promise((resolve) => {
		const script: any = document.createElement('script')
		script.type = 'text/javascript'
		script.src = url
		document.body.appendChild(script)
		if (script.readyState) {
			script.onreadystatechange = () => {
				if (['loaded', 'complete'].includes(script.readyState)) {
					script.onreadystatechange = null
					resolve(null)
				}
			}
		} else {
			script.onload = resolve
		}
	})
}


// 是否为微信浏览器
export function isWXBrowser() {
	const ua = navigator.userAgent.toLocaleLowerCase()
	if (/MicroMessenger/i.test(ua)) {
		return true;
	} else {
		return false;
	}
}


export function fileSelect(props?: { multiple?: boolean, accept?: string }) {
	return new Promise<File>((resolve, reject) => {
		const inputId = '_input_file_selector'

		let fileInputDom = document.getElementById(inputId) as HTMLInputElement
		if (!fileInputDom) {
			fileInputDom = document.createElement('input')
			fileInputDom.setAttribute('id', inputId)
			fileInputDom.style.display = "none"
			document.body.appendChild(fileInputDom)
		}
		const { multiple, accept } = props || {}
		fileInputDom.type = "file"
		fileInputDom.multiple = !!multiple
		if (accept) {
			fileInputDom.accept = accept
		}

		fileInputDom.addEventListener('change', (event) => {
			const target: any = event.target
			const files = target.files;
			if (files.length <= 0) {
				reject()
			}
			const file = files[0]
			resolve(file)
		})

		fileInputDom.addEventListener('error', (event) => {
			reject(event)
		})

		fileInputDom.click()
	})
}

/**
根据身份证号码判断性别
15位身份证号码：第7、8位为出生年份(两位数)，第9、10位为出生月份，第11、12位代表出生日
18位身份证号码：第7、8、9、10位为出生年份(四位数)，第11、第12位为出生月份，
第13、14位代表出生日期，第17位代表性别，奇数为男，偶数为女。
*/
//根据身份证号获取年龄
export function GetAge(identityCard:string) {
	const len = (identityCard + "").length;
	let strBirthday = "";
	if (len == 18) {
		//处理18位的身份证号码从号码中得到生日和性别代码
		strBirthday =
			identityCard.substr(6, 4) +
			"/" +
			identityCard.substr(10, 2) +
			"/" +
			identityCard.substr(12, 2);
	}
	if (len == 15) {
		let birthdayValue = "";
		birthdayValue = identityCard.charAt(6) + identityCard.charAt(7);
		if (parseInt(birthdayValue) < 10) {
			strBirthday =
				"20" +
				identityCard.substr(6, 2) +
				"/" +
				identityCard.substr(8, 2) +
				"/" +
				identityCard.substr(10, 2);
		} else {
			strBirthday =
				"19" +
				identityCard.substr(6, 2) +
				"/" +
				identityCard.substr(8, 2) +
				"/" +
				identityCard.substr(10, 2);
		}
	}
	//时间字符串里，必须是“/”
	const birthDate = new Date(strBirthday);
	const nowDateTime = new Date();
	let age = nowDateTime.getFullYear() - birthDate.getFullYear();
	//再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
	if (
		nowDateTime.getMonth() < birthDate.getMonth() ||
		(nowDateTime.getMonth() == birthDate.getMonth() &&
			nowDateTime.getDate() < birthDate.getDate())
	) {
		age--;
	}
	return age;
}

/**
 * 
 * @param name 正则
 * @returns 
 */

export function regular(name: string): RegExp {
	const reg = {
		phone: /^1\d{10}$/,
		identify: /(^\d{17}(\d|x)$)|(^\d{15}$)/i,
		bankCard: /^[0-9]{13,21}$/,
	}
	return reg[name]
}

/**
 * 校验手机
 */
export function verifyPhone(_: any, value: string) {
	if (!value) {
		return Promise.reject(new Error('请输入手机号码'))
	}
	if (regular('phone').test(value)) {
		return Promise.resolve()
	}
	return Promise.reject(new Error('请输入正确的手机号'))
}

/**
 * 校验身份证
 */
export function verifyIdentify(_: any, value: string) {
	if (!value) {
		return Promise.reject(new Error('请输入身份证号'))
	}
	if (regular('identify').test(value)) {
		const age = GetAge(value)
		if (age<18 || age>55) {
			return Promise.reject(new Error('仅支持18-55周岁人群申请此业务'))
		}
		return Promise.resolve()
	}
	return Promise.reject(new Error('请输入正确的身份证号'))
}

/**
 * 校验银行卡
 */
export function verifyBankCard(_: any, value: string) {
	if (!value) {
		return Promise.reject(new Error('请输入银行卡'))
	}
	if (regular('bankCard').test(value)) {
		return Promise.resolve()
	}
	return Promise.reject(new Error('请输入正确的银行卡'))
}
